import { FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { AddLiabilityManualForm } from './add-liability-manual.form';

export const billerIdOrNipRequiredValidator: ValidatorFn = (form: AddLiabilityManualForm): ValidationErrors | null => {
  if (isNull(form.nip) && isNull(form.billerId)) {
    form.nip.setErrors({ billerIdOrNipRequired: true });
    return { billerIdOrNipRequired: true };
  } else {
    const currentErrors = form.nip.errors;
    if (currentErrors) {
      delete currentErrors['billerIdOrNipRequired'];
      if (Object.keys(currentErrors).length === 0) {
        form.nip.setErrors(null);
      } else {
        form.nip.setErrors(currentErrors);
      }
    }
    return null;
  }
};

function isNull(control: FormControl): boolean {
  return control.value === null || control.value === '';
}
